const ONE_SECOND = 1000

export const secondsToMs = (seconds) => seconds * ONE_SECOND
export const minutesToMs = (minutes) => secondsToMs(60 * minutes)
